export default __webpack_public_path__ + "static/media/StudioMaincopy.93a31a82.png";